import { Layers, Fan, Wind, Factory, Gauge } from "lucide-react";
import { Reveal, ChapterTag, SectionTitle } from "./Reveal";

const SPECS = [
  {
    icon: Layers,
    name: "Panel Insulated",
    desc: "Panel dinding dengan lapisan insulasi yang menjaga temperatur ruangan tetap stabil dan mengurangi beban kerja mesin.",
    spec: "Tebal 75–150 mm",
  },
  {
    icon: Factory,
    name: "Refrigeration Unit",
    desc: "Jantung sistem pendingin. Kapasitasnya disesuaikan dengan volume ruangan dan target temperatur Anda.",
    spec: "Kapasitas sesuai perhitungan",
  },
  {
    icon: Wind,
    name: "Evaporator",
    desc: "Mendistribusikan udara dingin secara merata ke seluruh sudut ruangan agar produk terjaga kualitasnya.",
    spec: "Distribusi udara merata",
  },
  {
    icon: Fan,
    name: "Condensing Unit",
    desc: "Membuang panas dari sistem refrigerasi ke luar ruangan sehingga siklus pendinginan berjalan efisien.",
    spec: "Efisiensi tinggi",
  },
  {
    icon: Gauge,
    name: "Digital Temperature Controller",
    desc: "Memudahkan monitoring dan pengaturan temperatur ruangan secara presisi, kapan pun dibutuhkan.",
    spec: "Kontrol suhu presisi",
  },
];

export function Specs() {
  return (
    <section id="spesifikasi" data-testid="technical-specs-section" className="relative py-24 sm:py-32 bg-navy-950">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <ChapterTag number="07" label="Spesifikasi Teknis" />
        <div className="flex flex-wrap items-end justify-between gap-6 mb-14">
          <SectionTitle>Komponen di Balik <span className="text-ice">Setiap Unit</span></SectionTitle>
          <Reveal delay={0.15}>
            <p className="max-w-sm text-steel text-base">Penjelasan sederhana komponen utama cold storage — tanpa jargon teknis yang membingungkan.</p>
          </Reveal>
        </div>

        <div className="border-t border-glacier/15">
          {SPECS.map((s, i) => (
            <Reveal key={s.name} delay={0.04 * i}>
              <div
                data-testid={`spec-row-${i}`}
                className="group grid sm:grid-cols-[64px_220px_1fr_auto] items-center gap-4 sm:gap-8 py-6 border-b border-glacier/15 hover:bg-navy-900/60 px-2 sm:px-4 transition-colors duration-200"
              >
                <span className="w-11 h-11 rounded-sm bg-navy-900 border border-glacier/25 flex items-center justify-center group-hover:border-ice/60 transition-colors">
                  <s.icon className="w-5 h-5 text-ice" />
                </span>
                <h3 className="font-display text-xl font-semibold uppercase tracking-wide text-frost">{s.name}</h3>
                <p className="text-sm text-steel leading-relaxed">{s.desc}</p>
                <span className="font-mono text-xs text-ice/80 tracking-wider justify-self-start sm:justify-self-end">{s.spec}</span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
